import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

const BuildingProjects = () => {
  const [buildings, setBuildings] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try {
      const [{ data: dd }, { data: bl }] = await Promise.all([
        axios.get('/api/masters/dropdowns'),
        axios.get('/api/buildings')
      ]);
      setStatuses((dd && dd.buildingStatuses) || []);
      setBuildings(bl || []);
    } catch (e) {
      toast.error('Failed to load buildings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  const removeBuilding = async (buildingId) => {
    try {
      await axios.delete(`/api/buildings/${buildingId}`);
      toast.success('Building deleted and related tasks removed');
      await loadData();
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Failed to delete building');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Building Projects</h1>
        <Link to="/dashboard" className="text-sm text-primary-600 hover:text-primary-700">Back to Dashboard</Link>
      </div>

      {loading ? (
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"></div>
      ) : (
        <div className="card">
          <div className="overflow-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left">
                  <th className="pr-4 py-2">Name</th>
                  <th className="pr-4 py-2">Address</th>
                  <th className="pr-4 py-2">Latitude</th>
                  <th className="pr-4 py-2">Longitude</th>
                  <th className="pr-4 py-2">State</th>
                  <th className="pr-4 py-2">District</th>
                  <th className="pr-4 py-2">Project Type</th>
                  <th className="pr-4 py-2">Status</th>
                  <th className="pr-4 py-2">Delete</th>
                </tr>
              </thead>
              <tbody>
                {buildings.map((b) => (
                  <tr key={b.building_id} className="border-t">
                    <td className="pr-4 py-2">{b.building_name}</td>
                    <td className="pr-4 py-2">{b.building_address}</td>
                    <td className="pr-4 py-2">{b.latitude}</td>
                    <td className="pr-4 py-2">{b.longitude}</td>
                    <td className="pr-4 py-2">{b.state_ut || b.building_state}</td>
                    <td className="pr-4 py-2">{b.district_name || b.building_district}</td>
                    <td className="pr-4 py-2">{b.building_project_type || '-'}</td>
                    <td className="pr-4 py-2">{statuses.find((s) => String(s.building_status_id) === String(b.status_id))?.building_status || '-'}</td>
                    <td className="pr-4 py-2"><button className="btn-danger" onClick={() => removeBuilding(b.building_id)}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default BuildingProjects;
